// src/components/cierreGeneral/ChartsPanel.jsx
import React, { useMemo } from 'react';

// Formato colones (₡)
function formatCRC(value) {
  const n = Number(value || 0);
  return n.toLocaleString('es-CR', {
    style: 'currency',
    currency: 'CRC',
    minimumFractionDigits: 2,
  });
}

function pct(a, b) {
  const A = Number(a || 0);
  const B = Number(b || 0);
  const total = A + B;
  if (total <= 0) return 0;
  return Math.round((A / total) * 100);
}

function DonutLike({ leftLabel, leftValue, rightLabel, rightValue }) {
  const leftPct = useMemo(() => pct(leftValue, rightValue), [leftValue, rightValue]);
  const rightPct = 100 - leftPct;

  return (
    <div className="cg-donut">
      <div className="cg-donut-ring" aria-label="comparación">
        <div className="cg-donut-left" style={{ width: `${leftPct}%` }} />
        <div className="cg-donut-right" style={{ width: `${rightPct}%` }} />
      </div>

      <div className="cg-donut-legend">
        <div className="cg-donut-item">
          <div className="cg-dot" />
          <div className="cg-donut-text">
            <div className="cg-donut-label">{leftLabel}</div>
            <div className="cg-donut-val">
              {formatCRC(leftValue)} <span className="cg-muted">({leftPct}%)</span>
            </div>
          </div>
        </div>

        <div className="cg-donut-item">
          <div className="cg-dot cg-dot-alt" />
          <div className="cg-donut-text">
            <div className="cg-donut-label">{rightLabel}</div>
            <div className="cg-donut-val">
              {formatCRC(rightValue)} <span className="cg-muted">({rightPct}%)</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function Breakdown({ title, rows }) {
  return (
    <div className="cg-card cg-card-inner">
      <div className="cg-card-title">{title}</div>
      <div className="cg-mini-list">
        {rows.map((r) => (
          <div className="cg-mini-row" key={r.label}>
            <span className="cg-mini-key">{r.label}</span>
            <span className="cg-mini-val">{formatCRC(r.value)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function ChartsPanel({ data }) {
  const charts = data?.charts || {};
  const ive = charts?.ingresosVsEgresos || {};
  const comp = charts?.cuentasComparativo || {};
  const breakdown = ive?.breakdown || {};

  return (
    <div className="cg-section">
      <div className="cg-section-header">
        <h3 className="cg-section-title">Gráficas comparativas</h3>
        <div className="cg-muted">
          Comparaciones rápidas para el rango seleccionado.
        </div>
      </div>

      <div className="cg-grid-2">
        <div className="cg-card cg-card-inner">
          <div className="cg-card-title">Ingresos vs Egresos</div>
          <DonutLike
            leftLabel="Ingresos"
            leftValue={ive?.ingresos || 0}
            rightLabel="Egresos"
            rightValue={ive?.egresos || 0}
          />
        </div>

        <div className="cg-card cg-card-inner">
          <div className="cg-card-title">CxC vs CxP</div>
          <DonutLike
            leftLabel="Cuentas por cobrar (rango)"
            leftValue={comp?.cuentasPorCobrarInRange || 0}
            rightLabel="Cuentas por pagar (al corte)"
            rightValue={comp?.cuentasPorPagarAtEnd || 0}
          />
        </div>
      </div>

      <div className="cg-grid-2">
        <Breakdown
          title="Desglose de Ingresos"
          rows={[
            { label: 'Ventas cobradas (sin crédito)', value: breakdown?.salesCollected || 0 },
            { label: 'Pagos recibidos (CxC)', value: breakdown?.arPayments || 0 },
            { label: 'Caja chica (ingresos)', value: breakdown?.cajaChicaIngresos || 0 },
          ]}
        />

        <Breakdown
          title="Desglose de Egresos"
          rows={[
            { label: 'Pagos a proveedores (CxP)', value: breakdown?.supplierPayments || 0 },
            { label: 'Caja chica (egresos)', value: breakdown?.cajaChicaEgresos || 0 },
          ]}
        />
      </div>
    </div>
  );
}
